/**
 * Time duration constants in milliseconds
 * Use these instead of hardcoded time calculations like `7 * 24 * 60 * 60 * 1000`
 */
export const TIME_MS = {
    ONE_DAY: 24 * 60 * 60 * 1000,
    ONE_WEEK: 7 * 24 * 60 * 60 * 1000,
    TWO_WEEKS: 14 * 24 * 60 * 60 * 1000,
    THIRTY_DAYS: 30 * 24 * 60 * 60 * 1000,
    NINETY_DAYS: 90 * 24 * 60 * 60 * 1000,
    ONE_YEAR: 365 * 24 * 60 * 60 * 1000,
} as const;

export const APP_CONSTANTS = {
    PAGINATION: {
        DEFAULT_LIMIT: 20,
        DASHBOARD_LIMIT: 10,
    },
    TIMEOUTS: {
        MOCK_DELAY: 800,
        POLL_INTERVAL: 30000,
        /** Timeout for Edge Function fetch calls (30 seconds) */
        FETCH_TIMEOUT: 30000,
        /** Simulated AI analysis delay for mock service (1.5 seconds) */
        ANALYSIS_DELAY: 1500,
    },
    ROLES: {
        SUPER_ADMIN: 'SUPER_ADMIN',
        OWNER: 'COMPANY_OWNER',
        REGIONAL_MANAGER: 'REGIONAL_MANAGER',
        PROPERTY_MANAGER: 'PROPERTY_MANAGER',
    },
    THEME: {
        LIGHT: 'light',
        DARK: 'dark',
    },
    ROUTES: {
        LOGIN: '/login',
        DASHBOARD: '/',
        ADMIN: '/admin',
        USERS: '/users',
        COMPLEX: '/complex',
        DOCUMENTS: '/documents',
        DOCUMENT_DETAIL: '/documents',
    },
    MESSAGES: {
        ERROR: {
            GENERIC: 'An error occurred. Please try again.',
            FETCH_FAILED: 'Failed to fetch data.',
            UNAUTHORIZED: 'You are not authorized to perform this action.',
        },
        SUCCESS: {
            SAVED: 'Changes saved successfully.',
            CREATED: 'Created successfully.',
        },
    },
};

/**
 * Score thresholds for ESA letter authenticity scoring.
 * One decision, one location — all score-based branching references these values.
 *
 * VERIFIED: score at or above this value is considered verified/passing.
 * REVIEW:   score at or above this value (but below VERIFIED) needs manual review.
 * CRITICAL: score below this value triggers a critical-severity flag.
 */
export const SCORE_THRESHOLDS = {
  VERIFIED: 80,
  REVIEW: 60,
  CRITICAL: 50,
} as const;

export const ESA_LETTER_PRICE = 20;

/**
 * Storgia Design System color tokens for use in JS/TS contexts
 * (charts, SVG attributes, inline styles where Tailwind classes can't reach).
 *
 * These values MUST stay in sync with tailwind.config.js — both read from
 * the same palette, this file just makes the hex values importable.
 */
export const COLORS = {
    BLURPLE: '#5865f2',
    LIGHT_BLURPLE: '#e0e3ff',
    DARK_BLURPLE: '#19175c',
    GREEN: '#10b981',
    EMERALD: '#34D399',
    TEAL: '#27D0A9',
    ACCENT_PINK: '#E83F87',
    CTA_DARK_PINK: '#C00054',
    PINK: '#f54cd2',
    DARK: '#1f1f1f',
    BLACK: '#000000',
    WHITE: '#ffffff',
    DARK_GREEN: '#002920',
    DARKBLUE: '#1a1a2e',
} as const;
